var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "modal_customer",
          attrs: {
            id: "modal-customer",
            title: _vm.title,
            size: "xl",
            lazy: "",
            centered: "",
            scrollable: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": "",
            "hide-footer": ""
          },
          on: { hidden: _vm.onHidden }
        },
        [
          _c("b-skeleton-wrapper", {
            attrs: { loading: _vm.isBusy },
            scopedSlots: _vm._u([
              {
                key: "loading",
                fn: function() {
                  return [
                    _c(
                      "b-card",
                      { attrs: { "bg-variant": "light" } },
                      [
                        _c(
                          "b-row",
                          { staticClass: "mb-2 mt-2" },
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: { width: "12%", height: "26%" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  attrs: { type: "input", height: "41%" }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: { width: "20%", height: "26%" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  attrs: { type: "input", height: "41%" }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: { width: "50%", height: "26%" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  attrs: { type: "input", height: "41%" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "4" } },
                              [
                                _c("b-skeleton", {
                                  staticClass: "mb-3",
                                  attrs: { width: "8%", height: "24%" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  attrs: {
                                    type: "input",
                                    width: "100%",
                                    height: "30%"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "4" } },
                              [
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: { width: "36%", height: "23%" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  attrs: {
                                    type: "input",
                                    width: "100%",
                                    height: "39%"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: { width: "10%", height: "26%" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  attrs: { type: "input", height: "43%" }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: { width: "10%", height: "26%" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  attrs: { type: "input", height: "43%" }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: { width: "10%", height: "26%" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  attrs: { type: "input", height: "43%" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "mb-2" },
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-skeleton", {
                                  attrs: { width: "16%", height: "100%" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { staticClass: "mb-0" },
                              [
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: { width: "27%", height: "17%" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: {
                                    type: "input",
                                    width: "100%",
                                    height: "29%"
                                  }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  attrs: { width: "35%", height: "15%" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: { width: "22%", height: "17%" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: {
                                    type: "input",
                                    width: "100%",
                                    height: "29%"
                                  }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  attrs: { width: "32%", height: "15%" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "mb-2" },
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: { width: "4%", height: "26%" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  attrs: { type: "input", height: "41%" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "mb-2" },
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: { width: "6%", height: "26%" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  attrs: { type: "input", height: "41%" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "mb-5" },
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: { width: "9%", height: "26%" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  attrs: { type: "input", height: "100%" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "mb-1" },
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-skeleton", {
                                  attrs: { width: "15%", height: "55%" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "mb-2" },
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: { width: "6%", height: "26%" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  attrs: { type: "input", height: "41%" }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: { width: "49%", height: "26%" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  attrs: { type: "input", height: "41%" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "mb-3" },
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: { width: "19%", height: "26%" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  attrs: { type: "input", height: "41%" }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: { width: "28%", height: "26%" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  attrs: { type: "input", height: "41%" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "mb-0" },
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: { width: "5%", height: "50%" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "mb-2" },
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: { width: "12%" }
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", {
                                  attrs: { type: "input", height: "50%" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              },
              {
                key: "default",
                fn: function() {
                  return [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-card",
                          { attrs: { "bg-variant": "light" } },
                          [
                            _c(
                              "b-row",
                              { staticClass: "align-items-end" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-town",
                                          label: "Город"
                                        }
                                      },
                                      [
                                        _c(
                                          "b-form-select",
                                          {
                                            attrs: {
                                              size: "sm",
                                              disabled: _vm.isDisabled,
                                              state: _vm.getFieldState(
                                                "town_id"
                                              )
                                            },
                                            model: {
                                              value: _vm.newItem.town_id,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.newItem,
                                                  "town_id",
                                                  $$v
                                                )
                                              },
                                              expression: "newItem.town_id"
                                            }
                                          },
                                          _vm._l(_vm.towns, function(option) {
                                            return _c(
                                              "option",
                                              {
                                                domProps: { value: option.id }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(option.name) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          }),
                                          0
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-marketing-source",
                                          label: "Источник"
                                        }
                                      },
                                      [
                                        _c(
                                          "b-form-select",
                                          {
                                            attrs: {
                                              size: "sm",
                                              disabled: _vm.isDisabled,
                                              state: _vm.getFieldState(
                                                "marketing_source_id"
                                              )
                                            },
                                            model: {
                                              value:
                                                _vm.newItem.marketing_source_id,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.newItem,
                                                  "marketing_source_id",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "newItem.marketing_source_id"
                                            }
                                          },
                                          _vm._l(_vm.marketingSources, function(
                                            option
                                          ) {
                                            return _c(
                                              "option",
                                              {
                                                domProps: { value: option.id }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(option.name) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          }),
                                          0
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-marketing-source-comment",
                                          label: "Источник комментарий"
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            type: "text",
                                            size: "sm",
                                            disabled: _vm.isDisabled
                                          },
                                          model: {
                                            value:
                                              _vm.newItem
                                                .marketing_source_comment,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.newItem,
                                                "marketing_source_comment",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "newItem.marketing_source_comment"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "align-items-end" },
                              [
                                _c(
                                  "b-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-urflag",
                                          label: _vm.$t(
                                            "message.customers.modal.urflagInput"
                                          )
                                        }
                                      },
                                      [
                                        _c("b-form-radio-group", {
                                          attrs: {
                                            size: "sm",
                                            options: _vm.options,
                                            disabled: _vm.isDisabled,
                                            name: "radioOptions"
                                          },
                                          model: {
                                            value: _vm.newItem.urflag,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.newItem,
                                                "urflag",
                                                $$v
                                              )
                                            },
                                            expression: "newItem.urflag"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-status",
                                          label: "Статус заказчика"
                                        }
                                      },
                                      [
                                        _c(
                                          "b-form-select",
                                          {
                                            attrs: {
                                              size: "sm",
                                              disabled: _vm.isDisabled
                                            },
                                            model: {
                                              value: _vm.newItem.status_id,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.newItem,
                                                  "status_id",
                                                  $$v
                                                )
                                              },
                                              expression: "newItem.status_id"
                                            }
                                          },
                                          [
                                            _c(
                                              "option",
                                              {
                                                domProps: { value: 0 || null }
                                              },
                                              [_vm._v("Выберите статус")]
                                            ),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.customerStatuses,
                                              function(option) {
                                                return _c(
                                                  "option",
                                                  {
                                                    key: option.id,
                                                    domProps: {
                                                      value: option.id
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(option.name) +
                                                        "\n                    "
                                                    )
                                                  ]
                                                )
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.newItem.urflag
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "b-row",
                                      { attrs: { cols: "3" } },
                                      [
                                        _c(
                                          "b-col",
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id: "group-inn",
                                                  label: _vm.$t(
                                                    "message.customers.modal.inn"
                                                  )
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    type: "text",
                                                    size: "sm",
                                                    disabled: _vm.isDisabled,
                                                    state: _vm.getFieldState(
                                                      "inn"
                                                    )
                                                  },
                                                  model: {
                                                    value: _vm.newItem.inn,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.newItem,
                                                        "inn",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "newItem.inn"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id: "group-kpp",
                                                  label: _vm.$t(
                                                    "message.customers.modal.kpp"
                                                  )
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    type: "text",
                                                    size: "sm",
                                                    disabled: _vm.isDisabled
                                                  },
                                                  model: {
                                                    value: _vm.newItem.kpp,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.newItem,
                                                        "kpp",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "newItem.kpp"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id: "group-ogrn",
                                                  label: _vm.$t(
                                                    "message.customers.modal.ogrn"
                                                  )
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    type: "text",
                                                    size: "sm",
                                                    disabled: _vm.isDisabled
                                                  },
                                                  model: {
                                                    value: _vm.newItem.ogrn,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.newItem,
                                                        "ogrn",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "newItem.ogrn"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          size: "sm",
                                          disabled:
                                            _vm.isEmpty(_vm.newItem.inn) ||
                                            _vm.isDisabled,
                                          variant: "secondary"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.findCustomerData()
                                          }
                                        }
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          staticClass: "mr-1",
                                          attrs: { icon: "file-signature" }
                                        }),
                                        _vm._v(
                                          "\n                Заполнить данными\n              "
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _c("div"),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  id: "group-name",
                                  label: _vm.$t(
                                    "message.customers.modal.nameInput"
                                  ),
                                  description: _vm.$t(
                                    "message.customers.modal.nameInputDescription"
                                  )
                                }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    type: "text",
                                    size: "sm",
                                    disabled: _vm.isDisabled,
                                    state: _vm.getFieldState("name")
                                  },
                                  model: {
                                    value: _vm.newItem.name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.newItem, "name", $$v)
                                    },
                                    expression: "newItem.name"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  id: "group-full-name",
                                  label: _vm.$t(
                                    "message.customers.modal.fullNameInput"
                                  ),
                                  description: _vm.$t(
                                    "message.customers.modal.fullNameInputDescription"
                                  )
                                }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "input-full-name",
                                    type: "text",
                                    size: "sm",
                                    disabled: _vm.isDisabled
                                  },
                                  model: {
                                    value: _vm.newItem.full_name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.newItem, "full_name", $$v)
                                    },
                                    expression: "newItem.full_name"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  id: "group-address",
                                  label: _vm.$t(
                                    "message.customers.modal.addressInput"
                                  )
                                }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    type: "text",
                                    size: "sm",
                                    disabled: _vm.isDisabled,
                                    placeholder: _vm.$t(
                                      "message.customers.modal.addressPlaceholder"
                                    )
                                  },
                                  model: {
                                    value: _vm.newItem.address,
                                    callback: function($$v) {
                                      _vm.$set(_vm.newItem, "address", $$v)
                                    },
                                    expression: "newItem.address"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  id: "group-phone",
                                  label: _vm.$t(
                                    "message.customers.modal.phoneInput"
                                  )
                                }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    type: "text",
                                    size: "sm",
                                    disabled: _vm.isDisabled,
                                    state: _vm.getFieldState("phone"),
                                    placeholder: _vm.$t(
                                      "message.customers.modal.phonePlaceholder"
                                    ),
                                    "aria-describedby": "inputLiveFeedbackPhone"
                                  },
                                  model: {
                                    value: _vm.newItem.phone,
                                    callback: function($$v) {
                                      _vm.$set(_vm.newItem, "phone", $$v)
                                    },
                                    expression: "newItem.phone"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  id: "group-description",
                                  label: _vm.$t(
                                    "message.customers.modal.descriptionInput"
                                  )
                                }
                              },
                              [
                                _c("b-form-textarea", {
                                  attrs: {
                                    size: "sm",
                                    disabled: _vm.isDisabled,
                                    placeholder: _vm.$t(
                                      "message.customers.modal.descriptionPlaceholder"
                                    ),
                                    rows: 3,
                                    "max-rows": 6
                                  },
                                  model: {
                                    value: _vm.newItem.description,
                                    callback: function($$v) {
                                      _vm.$set(_vm.newItem, "description", $$v)
                                    },
                                    expression: "newItem.description"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("h6", [_vm._v("Банковские реквизиты")]),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { attrs: { cols: "2" } },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-bik",
                                          label: _vm.$t(
                                            "message.customers.modal.bik"
                                          )
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            size: "sm",
                                            autocomplete: "off",
                                            disabled: _vm.isDisabled
                                          },
                                          model: {
                                            value: _vm.newItem.bik,
                                            callback: function($$v) {
                                              _vm.$set(_vm.newItem, "bik", $$v)
                                            },
                                            expression: "newItem.bik"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-cor-account",
                                          label: _vm.$t(
                                            "message.customers.modal.cor_account"
                                          )
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            size: "sm",
                                            autocomplete: "off",
                                            disabled: _vm.isDisabled
                                          },
                                          model: {
                                            value: _vm.newItem.cor_account,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.newItem,
                                                "cor_account",
                                                $$v
                                              )
                                            },
                                            expression: "newItem.cor_account"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-bank",
                                          label: _vm.$t(
                                            "message.customers.modal.bank"
                                          )
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            size: "sm",
                                            autocomplete: "off",
                                            disabled: _vm.isDisabled
                                          },
                                          model: {
                                            value: _vm.newItem.bank,
                                            callback: function($$v) {
                                              _vm.$set(_vm.newItem, "bank", $$v)
                                            },
                                            expression: "newItem.bank"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-checking-account",
                                          label: _vm.$t(
                                            "message.customers.modal.checking_account"
                                          )
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            size: "sm",
                                            autocomplete: "off",
                                            disabled: _vm.isDisabled
                                          },
                                          model: {
                                            value: _vm.newItem.checking_account,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.newItem,
                                                "checking_account",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "newItem.checking_account"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("h6", { staticClass: "mt-2" }, [
                              _vm._v("Скидки")
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { attrs: { cols: "2" } },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-sale",
                                          label: _vm.$t(
                                            "message.customers.modal.saleInput"
                                          )
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            type: "number",
                                            size: "sm",
                                            disabled: _vm.isDisabled
                                          },
                                          model: {
                                            value: _vm.newItem.sale,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.newItem,
                                                "sale",
                                                _vm._n($$v)
                                              )
                                            },
                                            expression: "newItem.sale"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-link",
                              {
                                directives: [
                                  {
                                    name: "b-toggle",
                                    rawName: "v-b-toggle:contact-collapse",
                                    arg: "contact-collapse"
                                  }
                                ],
                                staticClass: "text-decoration-none"
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "when-open" },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "chevron-up" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "when-closed" },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "chevron-down" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("font-awesome-icon", {
                                  attrs: { icon: "id-card" }
                                }),
                                _vm._v(" Контакты\n            ")
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-collapse",
                              { attrs: { id: "contact-collapse" } },
                              [
                                _c("b-table", {
                                  ref: "customer_contacts",
                                  staticClass: "mb-0",
                                  attrs: {
                                    id: "customer-contacts",
                                    small: "",
                                    "thead-class": "d-none",
                                    "table-class": "text-small",
                                    responsive: "",
                                    "show-empty": "",
                                    "empty-text": _vm.$t(
                                      "message.common.emptyTable"
                                    ),
                                    busy: _vm.isBusyContacts,
                                    items: _vm.newItem.contacts,
                                    fields: _vm.contactsFields
                                  },
                                  on: {
                                    "update:busy": function($event) {
                                      _vm.isBusyContacts = $event
                                    }
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "table-busy",
                                      fn: function() {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-center text-success my-2"
                                            },
                                            [
                                              _c("b-spinner", {
                                                staticClass: "align-middle"
                                              }),
                                              _vm._v(" "),
                                              _c("strong", [_vm._v("Загрузка")])
                                            ],
                                            1
                                          )
                                        ]
                                      },
                                      proxy: true
                                    },
                                    {
                                      key: "cell(phone)",
                                      fn: function(row) {
                                        return [
                                          _c("label", [_vm._v("Телефон")]),
                                          _vm._v(" "),
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "input-phone",
                                              size: "sm",
                                              autocomplete: "off"
                                            },
                                            model: {
                                              value: row.item.phone,
                                              callback: function($$v) {
                                                _vm.$set(row.item, "phone", $$v)
                                              },
                                              expression: "row.item.phone"
                                            }
                                          })
                                        ]
                                      }
                                    },
                                    {
                                      key: "cell(name)",
                                      fn: function(row) {
                                        return [
                                          _c("label", [_vm._v("ФИО")]),
                                          _vm._v(" "),
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "input-name",
                                              size: "sm",
                                              autocomplete: "off"
                                            },
                                            model: {
                                              value: row.item.name,
                                              callback: function($$v) {
                                                _vm.$set(row.item, "name", $$v)
                                              },
                                              expression: "row.item.name"
                                            }
                                          })
                                        ]
                                      }
                                    },
                                    {
                                      key: "cell(email)",
                                      fn: function(row) {
                                        return [
                                          _c("label", [_vm._v("Email")]),
                                          _vm._v(" "),
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "input-email",
                                              size: "sm",
                                              autocomplete: "off"
                                            },
                                            model: {
                                              value: row.item.email,
                                              callback: function($$v) {
                                                _vm.$set(row.item, "email", $$v)
                                              },
                                              expression: "row.item.email"
                                            }
                                          })
                                        ]
                                      }
                                    },
                                    {
                                      key: "cell(description)",
                                      fn: function(row) {
                                        return [
                                          _c("label", [_vm._v("Дополнение")]),
                                          _vm._v(" "),
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "input-description",
                                              size: "sm",
                                              autocomplete: "off"
                                            },
                                            model: {
                                              value: row.item.description,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  row.item,
                                                  "description",
                                                  $$v
                                                )
                                              },
                                              expression: "row.item.description"
                                            }
                                          })
                                        ]
                                      }
                                    },
                                    {
                                      key: "cell(action)",
                                      fn: function(row) {
                                        return [
                                          _c(
                                            "b-button",
                                            {
                                              attrs: {
                                                disabled: _vm.isDisabled,
                                                size: "sm",
                                                variant: "danger"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.removeContact(row)
                                                }
                                              }
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                attrs: { icon: "trash" }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ])
                                }),
                                _vm._v(" "),
                                _c(
                                  "b-link",
                                  {
                                    staticClass:
                                      "text-decoration-none text-success text-small",
                                    attrs: { disabled: _vm.isDisabled },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.addEmptyContact.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "mr-1",
                                      attrs: { icon: "plus" }
                                    }),
                                    _vm._v(
                                      "\n                Добавить\n              "
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          [
            _c(
              "div",
              { staticClass: "w-100 d-flex justify-content-end py-2" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "mr-2",
                    attrs: { size: "sm", variant: "secondary" },
                    on: { click: _vm.handleCancel }
                  },
                  [_vm._v("\n          Отменить\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    attrs: {
                      size: "sm",
                      variant: "success",
                      disabled: _vm.isDisabled || _vm.loading
                    },
                    on: { click: _vm.handleOk }
                  },
                  [
                    _vm.loading
                      ? _c("b-spinner", { attrs: { small: "" } })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("font-awesome-icon", {
                      staticClass: "mr-1",
                      attrs: { icon: "save" }
                    }),
                    _vm._v("\n          Сохранить\n        ")
                  ],
                  1
                )
              ],
              1
            )
          ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66f8dea8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66f8dea8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Customers/Customer.vue
// module id = null
// module chunks = 